import { render, staticRenderFns } from "./ReferenceVsLocalRisk.vue?vue&type=template&id=35da906a"
import script from "./ReferenceVsLocalRisk.vue?vue&type=script&lang=js"
export * from "./ReferenceVsLocalRisk.vue?vue&type=script&lang=js"
import style0 from "./ReferenceVsLocalRisk.vue?vue&type=style&index=0&id=35da906a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports